var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4992_3421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.81641 5V6.5H13.2617L0.816406 18.9453L1.87109 20L14.3164 7.55469V17H15.8164V5H3.81641Z",
    fill: "#006106"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4992_3421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.816406 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrow);
export default __webpack_public_path__ + "static/media/green-arrow.d3edb1aab5e7633604d65d9e5ea46aed.svg";
export { ForwardRef as ReactComponent };